import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SITE } from "../mock";
import EnquiryForm from "./EnquiryForm";
import { X, Phone, MessageCircle, Gift, Clock, Mail, MapPin as MapPinIcon } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-[#2a1212] text-white/85">
      {/* MahaRERA Strip */}
      <div className="bg-[#1a0a0a] border-b border-[#C9A24B]/30">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 flex flex-col md:flex-row items-start md:items-center justify-between gap-2">
          <div className="text-[12px] md:text-[13px] text-[#F2D88E] font-medium tracking-wide">
            <span className="text-white/70 mr-2">Bhima Kamble MahaRERA No:</span>
            <b className="text-white">{SITE.agentRera}</b>
            <span className="text-white/40 mx-3 hidden md:inline">|</span>
            <span className="block md:inline text-white/70 mr-2 md:ml-0">
              Project MahaRERA Registration No:
            </span>
            <b className="text-white">{SITE.projectRera}</b>
          </div>
          <a
            href="https://maharera.maharashtra.gov.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[11px] text-[#C9A24B] hover:text-white underline-offset-2 hover:underline"
          >
            Verify on MahaRERA →
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Brand + About */}
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-10 h-10 bg-[#C9A24B] rounded flex items-center justify-center text-[#1a1a1a] font-serif-display text-xl font-bold">G</div>
            <div>
              <div className="font-serif-display text-xl font-bold text-white">Godrej Elaris</div>
              <div className="text-[11px] text-[#C9A24B]">Magarpatta–Mundhwa, Pune</div>
            </div>
          </div>
          <p className="text-[12px] leading-relaxed text-white/65">
            Marketed by <b className="text-white/90">Bhima Kamble</b>, an authorized
            channel partner. Premium 2, 3, 3.5 &amp; 4 BHK apartments and curated retail spaces
            in the heart of Magarpatta, Pune.
          </p>
        </div>

        {/* About & Disclaimer */}
        <div>
          <h4 className="text-white font-semibold mb-3 uppercase tracking-widest text-[11px] border-b border-[#C9A24B]/30 pb-2">
            About &amp; Disclaimer
          </h4>
          <p className="text-[12px] leading-relaxed text-white/65">
            Disclaimer: This is not the official developer website. This website is operated by
            Bhima Kamble, an authorized channel partner for Godrej Elaris, for
            informational and marketing purposes.
          </p>
        </div>

        {/* MahaRERA Registrations */}
        <div>
          <h4 className="text-white font-semibold mb-3 uppercase tracking-widest text-[11px] border-b border-[#C9A24B]/30 pb-2">
            MahaRERA Registrations
          </h4>
          <ul className="text-[12px] space-y-2 text-white/75">
            <li>
              <div className="text-white/55 text-[10px] uppercase tracking-wider mb-0.5">
                Channel Partner
              </div>
              <div className="font-medium">Bhima Kamble</div>
              <div className="text-[#F2D88E]">MahaRERA No: {SITE.agentRera}</div>
            </li>
            <li>
              <div className="text-white/55 text-[10px] uppercase tracking-wider mb-0.5">
                Project
              </div>
              <div className="font-medium">Godrej Elaris</div>
              <div className="text-[#F2D88E]">RERA No: {SITE.projectRera}</div>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-white font-semibold mb-3 uppercase tracking-widest text-[11px] border-b border-[#C9A24B]/30 pb-2">
            Contact Details
          </h4>
          <ul className="text-[12px] space-y-3 text-white/80">
            <li className="flex items-start gap-2">
              <Mail className="w-3.5 h-3.5 mt-0.5 text-[#C9A24B] shrink-0" />
              <a
                href={`mailto:${SITE.email}`}
                className="break-all hover:text-[#C9A24B]"
              >
                {SITE.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Phone className="w-3.5 h-3.5 mt-0.5 text-[#C9A24B] shrink-0" />
              <a href={`tel:${SITE.phoneRaw}`} className="hover:text-[#C9A24B]">
                {SITE.phone}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPinIcon className="w-3.5 h-3.5 mt-0.5 text-[#C9A24B] shrink-0" />
              <span className="leading-relaxed text-white/70">{SITE.siteAddress}</span>
            </li>
            <li>
              <a
                href={`https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(SITE.whatsappMessage)}`}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1.5 text-green-400 hover:text-green-300 mt-1"
              >
                <MessageCircle className="w-3.5 h-3.5" /> WhatsApp Chat
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex flex-col md:flex-row items-center justify-between gap-2 text-[11px] text-white/55">
          <div>© {new Date().getFullYear()} Bhima Kamble. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <Link
              to="/privacy-policy"
              className="text-white/80 hover:text-[#C9A24B] underline-offset-2 hover:underline"
            >
              Privacy Policy
            </Link>
            <span className="text-white/20">•</span>
            <a href="/#contact" className="hover:text-[#C9A24B]">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export function StickyMobileCTA({ onEnquire }) {
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 md:hidden grid grid-cols-3 bg-white border-t border-[#ecdfc9] shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
      <a href={`tel:${SITE.phoneRaw}`} className="flex flex-col items-center justify-center py-2.5 text-[#8B1E1E]">
        <Phone className="w-5 h-5" /> <span className="text-[11px] font-semibold mt-0.5">Call</span>
      </a>
      <a href={`https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(SITE.whatsappMessage)}`} target="_blank" rel="noreferrer" className="flex flex-col items-center justify-center py-2.5 bg-green-600 text-white">
        <MessageCircle className="w-5 h-5" /> <span className="text-[11px] font-semibold mt-0.5">WhatsApp</span>
      </a>
      <button onClick={onEnquire} className="flex flex-col items-center justify-center py-2.5 bg-[#8B1E1E] text-white">
        <Gift className="w-5 h-5" /> <span className="text-[11px] font-semibold mt-0.5">Enquire</span>
      </button>
    </div>
  );
}

export function WhatsAppFloat() {
  return (
    <a href={`https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(SITE.whatsappMessage)}`} target="_blank" rel="noreferrer"
      className="fixed bottom-20 md:bottom-6 right-4 md:right-6 z-40 wa-float" aria-label="Chat on WhatsApp">
      <div className="bg-green-500 hover:bg-green-600 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg">
        <MessageCircle className="w-7 h-7" />
      </div>
    </a>
  );
}

export function EnquiryModal({ open, onClose, title = "Get Best Offers" }) {
  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose}>
      <div className="relative bg-white rounded-lg w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} aria-label="close" className="absolute top-3 right-3 w-8 h-8 rounded-full bg-[#faf1dc] flex items-center justify-center hover:bg-[#ecdfc9]">
          <X className="w-4 h-4 text-[#8B1E1E]" />
        </button>
        <div className="p-1">
          <EnquiryForm title={title} subtitle="Just 3 quick details — brochure, floor plans &amp; a callback within minutes." source="popup_modal" />
        </div>
      </div>
    </div>
  );
}

export function OfferBanner() {
  return (
    <div className="bg-gradient-to-r from-[#faf1dc] to-[#f7e6c0] border-y border-[#e7d3a6] py-3">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-[#5a1212] text-sm font-medium">
          <Clock className="w-4 h-4" />
          <span>Limited-Time Pre-Launch Offer • Assured Gifts on Site Visit • Best Floor Rise Selection</span>
        </div>
        <a href={`tel:${SITE.phoneRaw}`} className="text-[#8B1E1E] font-bold text-sm hover:underline">Call {SITE.phone} →</a>
      </div>
    </div>
  );
}

/** Trigger: entry popup after 30s only (no scroll / no exit-intent) */
export function useSmartPopups(openModal) {
  useEffect(() => {
    const t = setTimeout(() => openModal(), 30000);
    return () => clearTimeout(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
